import { render } from "./LoaderBlock.vue?vue&type=template&id=5e3eaaf5&scoped=true"
import script from "./LoaderBlock.vue?vue&type=script&lang=js"
export * from "./LoaderBlock.vue?vue&type=script&lang=js"

import "./LoaderBlock.vue?vue&type=style&index=0&id=5e3eaaf5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3eaaf5"]])

export default __exports__